import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAssetType,
  selectAssetType,
  setDataSuccess
} from 'src/features/staticDataSlice';
import { checkPermission } from 'src/utils/permission';
import AssetTypeCreateModal from 'src/pages/PolicyProduct/RiskFactor/AssetType/AssetTypeCreateModal';

const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function AssetTypeList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [assetTypeCreatePermission, setAssetTypeCreatePermission] = useState(false);

  const assetTypeData = useSelector(selectAssetType);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setAssetTypeCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('assetType', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchAssetType(productId).then(data =>
      dispatch(setDataSuccess({ dataType: 'assetType', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Replace with validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-assetType" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-assetType"
          id="select-assetType"
          value={tableListDatas[index]?.assetType || ''}
          onChange={(event) => {
            handleChange('assetType', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {assetTypeData?.map((asset) => (
            <MenuItem key={asset.id} value={asset.assetName}>
              {asset.assetName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              assetTypeCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Asset Type
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (assetTypeCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: assetTypeCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <AssetTypeCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default AssetTypeList;
